import React, { useState } from 'react';
import { Button, InputNumber, Modal } from 'antd';

import {
  useAddFeedCredits,
  useCreateTeamFeedBalance,
} from 'client/modules/data-feed-credit/hooks/queries/data-feed-credit';

export const CreateTeamBalanceButton = ({
  className,
  team: { idTeam, name },
}: {
  className?: string;
  team: { idTeam: number; name: string };
}): React.ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amount, setAmount] = useState(0);
  const createBalance = useCreateTeamFeedBalance();
  const addCredits = useAddFeedCredits();
  const hasError = Boolean(createBalance.error || addCredits.error);
  const isLoading = createBalance.isLoading || addCredits.isLoading;

  const closeModal = () => {
    setIsModalOpen(false);
    setAmount(0);
    createBalance.reset();
  };

  const submitCreateBalance = () => {
    createBalance
      .mutateAsync(idTeam)
      .then(() => amount > 0 && addCredits.mutateAsync({ idTeam, amount }))
      .then(closeModal);
  };

  return (
    <>
      <Button
        className={className}
        onClick={() => setIsModalOpen(true)}
        type="primary"
      >
        Create Credit Balance
      </Button>
      <Modal
        title={`Create Data Feed Credit Balance for ${name}?`}
        visible={isModalOpen}
        okButtonProps={{ disabled: isLoading, loading: isLoading }}
        onOk={submitCreateBalance}
        onCancel={() => {
          if (!isLoading) closeModal();
        }}
      >
        <InputNumber
          addonBefore="Initial Amount"
          autoFocus
          min={0}
          max={100000000}
          onChange={(value) => setAmount(Number(value) || 0)}
          onPressEnter={submitCreateBalance}
          step={1000}
          value={amount}
        />
        {hasError && (
          <p className="text-red-600 text-sm mt-2">
            Something went wrong, please try again.
          </p>
        )}
      </Modal>
    </>
  );
};

export default CreateTeamBalanceButton;
